module.exports = __webpack_public_path__ + "static/media/paint-roller.b31b561c.svg";